import { render, staticRenderFns } from "./SeminarReserve.vue?vue&type=template&id=d2bb0efe&scoped=true&"
import script from "./SeminarReserve.vue?vue&type=script&lang=js&"
export * from "./SeminarReserve.vue?vue&type=script&lang=js&"
import style0 from "./SeminarReserve.vue?vue&type=style&index=0&id=d2bb0efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bb0efe",
  null
  
)

export default component.exports